// extracted by mini-css-extract-plugin
export default {"wrapper":"logos_wrapper__R-Zna","logo":"logos_logo__WqseB"};